<div class="absolute inset-0 bg-black/50 z-50 flex items-center justify-center backdrop-blur-sm">
  <div class="bg-bg flex flex-col gap-2 p-6 mx-5 rounded-[32px] w-[525px] max-w-[90vw]">
    <div class="flex flex-col">
      <img src="assets/icon/popup/warning-info.png" alt="warning" width="80" height="80" />

      <div class="flex flex-col gap-1 py-2">
        <h3 class="font-semibold text-text-primary text-2xl">{{ title() }}</h3>
        <span class="text-base text-text-secondary font-normal">{{ description() }}</span>
      </div>
    </div>
    <div class="pt-4 flex justify-between gap-2">
      <button
        class="w-full app-button app-button__solid-secondary py-2 px-3 h-12 text-base text-text-primary font-semibold font-heading"
        (click)="cancelEvt.emit()"
      >
        {{ cancelText() }}
      </button>
      <button
        class="w-full app-button app-button__secondary py-2 px-3 h-12 text-base font-semibold font-heading"
        (click)="confirmEvt.emit()"
      >
        {{ confirmText() }}
      </button>
    </div>
  </div>
</div>
